import React from 'react';

export const LoadingAnimation = () => (
  <div>
    <div className="loading-outer">
      <div className="loading-inner">
        <div className="loading-item loading-item0">L</div>
        <div className="loading-item loading-item1">O</div>
        <div className="loading-item loading-item2">A</div>
        <div className="loading-item loading-item3">D</div>
        <div className="loading-item loading-item4">I</div>
        <div className="loading-item loading-item5">N</div>
        <div className="loading-item loading-item6">G</div>
        <div className="loading-shadow"></div>
      </div>
    </div>
    <div className="loading-text-wrapper">
      <h3 className="loadingText">Loading...</h3>
    </div>
  </div>
);
